import React from "react";
import Typography from "@mui/material/Typography";

import { TAB_DISCRIMINATORS } from "../dashboardConstants";
import BookingRow from "./BookingRow";
import { bookingRowKey } from "../dashboardHelpers";
import TermRow from "./TermRow";
import PackageRow from "./PackageRow";
import VoucherRow from "./VoucherRow";
import InvoiceRow from "./InvoiceRow";

function ActivityList({
  tab,
  items,
  currency,
  onCancel,
  onReschedule,
  onPayNow,
  onSettleBooking,
  onCheckIn,
  payLoadingId,
  onViewInvoice,
  onViewUsage,
  onViewGame,
  onViewClass
}) {
  const discriminator = TAB_DISCRIMINATORS[tab];
  const filtered = discriminator ? items.filter((i) => i && discriminator in i) : items;

  if (!filtered.length) {
    return (
      <Typography variant="body2" color="textSecondary">
        No {tab} found
      </Typography>
    );
  }

  if (tab === "bookings") {
    return filtered.map((b) => (
      <BookingRow
        key={bookingRowKey(b)}
        booking={b}
        onCancel={onCancel}
        onReschedule={onReschedule}
        onPayNow={onPayNow}
        onSettleBooking={onSettleBooking}
        onCheckIn={onCheckIn}
        payLoadingId={payLoadingId}
        onViewInvoice={onViewInvoice}
        onViewGame={onViewGame}
        onViewClass={onViewClass}
      />
    ));
  }
  if (tab === "terms") {
    return filtered.map((t) => <TermRow key={t._id} term={t} />);
  }
  if (tab === "packages") {
    return filtered.map((p) => <PackageRow key={p._id} pkg={p} onPayNow={onPayNow} payLoadingId={payLoadingId} onViewUsage={onViewUsage} />);
  }
  if (tab === "vouchers") {
    return filtered.map((v) => <VoucherRow key={v._id} voucher={v} currency={currency} onPayNow={onPayNow} payLoadingId={payLoadingId} />);
  }
  if (tab === "invoices") {
    return filtered.map((i) => (
      <InvoiceRow key={i._id} invoice={i} currency={currency} onPayNow={onPayNow} payLoadingId={payLoadingId} onView={onViewInvoice} />
    ));
  }
  return null;
}

export default ActivityList;
